<script setup>
const props = defineProps({
  href: [Object,String],
  target: String,
  isMoto: {
      type: Boolean,
      default: false
    }
},
)

const route = useRoute();
const isActive = computed(() => {
  if (props.isMoto) return false;
  
  if (typeof props.href === 'object' && props.href.name) {
    return route.name && route.name.includes(props.href.name);
  }
  return route.path === props.href;
});
</script>

<template>
  <NuxtLink
    :to="props.href"
    :target="target"
    :class="[
      isMoto ? 'xl:flex' : 'xl:flex',
      !isMoto && isActive ? 'text-azure' : ''
    ]"
    class="font-extralight text-sm hover:text-azure cursor-pointer transition-colors max-lg:hidden justify-center items-center whitespace-nowrap"
  >
      <slot />
  </NuxtLink>
</template>
